import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmillionmindstech() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Million Minds Tech City Ahmedabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Million Minds Tech City Ahmedabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Million Minds Tech City Ahmedabad, catering to the transportation needs of IT companies, corporate offices, and business centers within the tech hub. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Million Minds Tech City Ahmedabad.',

    top: 'Top Places to Visit in Ahmedabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, located on the banks of the Sabarmati River, was the home of Mahatma Gandhi for over a decade and served as a major center for the Indian freedom movement. Visitors can explore Gandhi’s simple living quarters, archives of letters, photographs, and exhibits explaining India’s struggle for independence. The peaceful environment, museum, and historical displays make it a place of deep reflection and national pride."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "The Sidi Saiyyed Mosque, built in 1573 during the Gujarat Sultanate period, is renowned for its iconic stone latticework windows known as the 'Sidi Saiyyed Jali'. These intricately carved screens depicting the famous ‘Tree of Life’ are considered masterpieces of Indo-Islamic art. The mosque offers visitors a chance to admire historic craftsmanship and experience one of Ahmedabad’s most recognized architectural symbols."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is a beautiful riverside development project that has transformed Ahmedabad’s waterfront into a vibrant public space. Featuring pedestrian walkways, gardens, cycling tracks, boating facilities, and event spaces, the riverfront is ideal for family outings, leisure walks, and evening relaxation. The well-maintained urban landscape and scenic views make it a preferred hangout spot for locals and tourists."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located just outside Ahmedabad, is a centuries-old five-story stepwell built in 1498 in Indo-Islamic architectural style. Known for its beautifully carved pillars, ornamental walls, and cooling subterranean design, the stepwell served as a resting place for travelers in earlier times. Today, it stands as an engineering and artistic marvel, offering visitors a glimpse into Gujarat’s architectural heritage."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is a large man-made lake that has evolved into one of Ahmedabad’s most popular recreational hubs. Surrounding the lake are amusement rides, toy trains, food stalls, a zoo, children’s play zones, and water activities, making it ideal for families. The illuminated musical fountain shows and clean walking paths make evenings at Kankaria lively and memorable."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of the most impressive mosques in Gujarat. Constructed from yellow sandstone, it features beautifully carved pillars, grand prayer halls, and a harmonious blend of Hindu and Islamic architectural influences. Visitors can explore the expansive courtyard and admire the detailed stonework, reflecting the historical importance of early Ahmedabad."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in the world, preserving centuries of India’s weaving, dyeing, printing, and embroidery traditions. Exhibits include royal costumes, temple cloths, carpets, and antique fabrics displayed in well-curated galleries. Visitors can gain a deep understanding of India's rich textile heritage, craftsmanship, and cultural evolution."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "Auto World Vintage Car Museum houses one of India’s largest collections of classic automobiles, including limousines, sports cars, convertibles, and royal vehicles from Europe and America. Many cars belonged to Indian princely families and are preserved in running condition. The museum offers a nostalgic journey into the history of automotive engineering and luxury travel."
  },
  {
    "title": "Hutheesing Jain Temple",
    "description": "Built in 1848, Hutheesing Jain Temple is a beautifully crafted marble temple dedicated to Lord Dharmanath. The temple features ornate carvings, elaborately decorated domes, and peaceful prayer halls that showcase the artistic traditions of Jain architecture. It is a serene spiritual destination and a remarkable example of Ahmedabad’s religious heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s famous city square known for its unique transformation throughout the day: a bustling vegetable market in the morning, a jewelry hub during the day, and a thriving street food destination at night. Visitors can enjoy traditional Gujarati snacks, sweets, and freshly prepared dishes, making it a must-visit spot for food lovers seeking authentic local flavors."
  }
],


"services": [
  {
    "name": "Million Minds Tech City Employee Cab Ahmedabad",
    "description": "Million Minds Tech City Employee Cab Ahmedabad provides reliable and tech-enabled transportation for employees working in Million Minds Tech City. The service includes well-maintained vehicles, experienced chauffeurs, and route optimization to ensure smooth and timely commuting for employees, catering to both fixed and flexible shift schedules."
  },
  {
    "name": "Corporate Shuttle Million Minds Ahmedabad",
    "description": "Corporate Shuttle Million Minds Ahmedabad offers high-capacity shuttle services designed to handle bulk employee transport to and from Million Minds Tech City. Equipped with AC minibuses and vans, the service ensures efficient routing, multi-shift support, and GPS-enabled tracking, making it ideal for large-scale workforce transportation."
  },
  {
    "name": "Business Cab Million Minds Tech City Ahmedabad",
    "description": "Business Cab Million Minds Tech City Ahmedabad offers executive-level transportation for business professionals. With a fleet of premium vehicles and experienced chauffeurs, the service ensures punctuality and comfort for meetings, conferences, airport transfers, and client visits within the tech city."
  },
  {
    "name": "Office Pickup Drop Million Minds Tech City Ahmedabad",
    "description": "Office Pickup Drop Million Minds Tech City Ahmedabad provides structured, pre-planned daily commute solutions for employees working in Million Minds Tech City. The service includes fixed routes, real-time tracking, and professional chauffeurs, ensuring smooth and reliable transportation for all workforce categories."
  },
  {
    "name": "Company Cab Million Minds Tech City Ahmedabad",
    "description": "Company Cab Million Minds Tech City Ahmedabad offers end-to-end corporate cab services for businesses based in Million Minds Tech City. With flexible routes, professional drivers, and tech-enabled fleet management, the service is designed to meet the diverse mobility needs of employees, executives, and visitors."
  },
  {
    "name": "Monthly Corporate Cab Million Minds Ahmedabad",
    "description": "Monthly Corporate Cab Million Minds Ahmedabad provides long-term transportation solutions for companies. With a fleet of sedans, SUVs, and shuttle vehicles, the service ensures consistent availability for employee commutes, client visits, and business events, while offering predictable costs and easy scheduling."
  },
  {
    "name": "Staff Transport Million Minds Tech City Ahmedabad",
    "description": "Staff Transport Million Minds Tech City Ahmedabad offers organized and dependable transportation for employees working in the tech city. The service includes optimized routes, well-maintained vehicles, and real-time monitoring to ensure timely arrivals and departures, making it an efficient option for large teams."
  },
  {
    "name": "Affordable Cab Million Minds Tech City Ahmedabad",
    "description": "Affordable Cab Million Minds Tech City Ahmedabad provides cost-effective transportation solutions without compromising on safety or comfort. This service is ideal for startups, small businesses, and mid-sized companies requiring reliable and budget-friendly travel options for their employees and business operations."
  },
  {
    "name": "Best Corporate Cabs Million Minds Ahmedabad",
    "description": "Best Corporate Cabs Million Minds Ahmedabad offers high-end vehicle rentals for executives and senior management. With premium sedans, SUVs, and well-trained chauffeurs, the service ensures luxury and comfort for all corporate travel, including airport transfers, business meetings, and client visits."
  },
  {
    "name": "Outstation Cab Million Minds Tech City Ahmedabad",
    "description": "Outstation Cab Million Minds Tech City Ahmedabad provides long-distance corporate travel solutions for business meetings, client visits, and site tours. The service includes a selection of comfortable sedans and SUVs, experienced chauffeurs, and interstate permits, ensuring smooth and reliable outstation travel for businesses."
  },
  {
    "name": "Sedan Cab Million Minds Ahmedabad",
    "description": "Sedan Cab Million Minds Ahmedabad offers premium sedans for corporate travel, including airport transfers, client meetings, and executive transportation. Well-maintained and driven by professional chauffeurs, this service guarantees comfort, punctuality, and a smooth travel experience for business professionals."
  },
  {
    "name": "SUV Cab Million Minds Tech City Ahmedabad",
    "description": "SUV Cab Million Minds Tech City Ahmedabad provides spacious and comfortable SUVs for business professionals, group transport, and outstation travel. With advanced safety features, comfortable interiors, and professional chauffeurs, this service is designed for those requiring extra space and comfort."
  },
  {
    "name": "Employee Mobility Million Minds Ahmedabad",
    "description": "Employee Mobility Million Minds Ahmedabad offers seamless commuting solutions for employees working in Million Minds Tech City. The service includes efficient routing, vehicle tracking, and flexible schedules, ensuring employees arrive on time and in comfort, whether for daily commutes or special work-related trips."
  },
  {
    "name": "Corporate Fleet Million Minds Ahmedabad",
    "description": "Corporate Fleet Million Minds Ahmedabad offers comprehensive fleet management services for businesses operating in Million Minds Tech City. The service includes fleet outsourcing, vehicle maintenance, driver management, GPS tracking, and customized transport plans to meet the unique needs of companies in the tech city."
  },
  {
    "name": "IT Park Cab Million Minds Tech City Ahmedabad",
    "description": "IT Park Cab Million Minds Tech City Ahmedabad offers dedicated, tech-driven transportation for employees, executives, and clients visiting Million Minds Tech City. The service includes modern vehicles, experienced chauffeurs, and route optimization to ensure reliable and safe travel across the IT park and surrounding areas."
  }
],

"tableData": [
  ["Million Minds Tech City Employee Cab Ahmedabad", "Corporate Shuttle Million Minds Ahmedabad"],
  ["Business Cab Million Minds Tech City Ahmedabad", "Office Pickup Drop Million Minds Tech City Ahmedabad"],
  ["Company Cab Million Minds Tech City Ahmedabad", "Monthly Corporate Cab Million Minds Ahmedabad"],
  ["Staff Transport Million Minds Tech City Ahmedabad", "Affordable Cab Million Minds Tech City Ahmedabad"],
  ["Best Corporate Cabs Million Minds Ahmedabad", "Outstation Cab Million Minds Tech City Ahmedabad"],
  ["Sedan Cab Million Minds Ahmedabad", "SUV Cab Million Minds Tech City Ahmedabad"],
  ["Employee Mobility Million Minds Ahmedabad", "Corporate Fleet Million Minds Ahmedabad"],
  ["IT Park Cab Million Minds Tech City Ahmedabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Million Minds Tech City Ahmedabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Million Minds Tech City Ahmedabad, ensuring smooth and efficient transportation for employees and business executives across the IT and corporate hub."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Million Minds Tech City and nearby business zones, helping professionals reach offices and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Million Minds Tech City."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate cab rental plans designed to meet the commuting needs of employees and businesses in Million Minds Tech City Ahmedabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking process and reliable coordination, making employee transport hassle-free."
  }
]




































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Million Minds Tech City, Ahmedabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and IT offices in Million Minds Tech City, Ahmedabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Million Minds Tech City?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and full fleet management for IT companies and offices.',
  },
  {
    question: 'Do you support daily employee commute services in Million Minds Tech City?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for corporate employees.',
  },
  {
    question: 'How can companies book corporate cab services in Million Minds Tech City?',
    answer: 'Bookings can be made via our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Million Minds Tech City?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts for companies in Million Minds Tech City?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and full fleet management solutions.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All our vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Million Minds Tech City?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Desai',
    feedback: 'Excellent corporate cab service for our Million Minds Tech City office. Drivers are punctual, and vehicles are clean and well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riddhi Patel',
    feedback: 'Reliable and professional transportation partner. Our employees are happy with the smooth and timely commute services.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Million Minds Tech City Ahmedabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-million-minds.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate cab services in Million Minds Tech City Ahmedabad, offering employee transportation, corporate shuttles, office pickup & drop, business cab services, monthly corporate cab plans, staff transport, outstation trips, IT park cab services, and complete corporate fleet solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-million-minds-tech-city-ahmedabad"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Million Minds Tech City Ahmedabad | Employee & IT Park Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Million Minds Tech City Ahmedabad including employee transport, corporate shuttle, office pickup & drop, business cabs, monthly corporate cab rentals, IT park cab services, outstation travel, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Million Minds Tech City Employee Cab Ahmedabad, Corporate Shuttle Million Minds Ahmedabad, Business Cab Million Minds Tech City Ahmedabad, Office Pickup Drop Million Minds Tech City Ahmedabad, Company Cab Million Minds Tech City Ahmedabad, Monthly Corporate Cab Million Minds Ahmedabad, Staff Transport Million Minds Tech City Ahmedabad, Affordable Cab Million Minds Tech City Ahmedabad, Best Corporate Cabs Million Minds Ahmedabad, Outstation Cab Million Minds Tech City Ahmedabad, Sedan Cab Million Minds Ahmedabad, SUV Cab Million Minds Tech City Ahmedabad, Employee Mobility Million Minds Ahmedabad, Corporate Fleet Million Minds Ahmedabad, IT Park Cab Million Minds Tech City Ahmedabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmillionmindstech;